import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {BeatLoader} from 'react-spinners'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import {get} from "../../../server/actions";
import {MONTH} from "../../../server/constants";

class Notifications extends Component {
    toggle = (e) => {
        let type = e.target.name
        this.setState({[e.target.name]: !this.state[e.target.name]}, () => {

            this.updateSettings(type)
        })
    }
    componentDidMount = () => {
        this.setState({loading:true})
        get('/reports/emailSendStatus?email=' + sessionStorage.getItem('loggedInUserInfo') + '&access_token='
        ).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({
                loading:false,
                lunchReminderEnable: data.lunchReminderEnable,
                paymentReminderEnable: data.paymentReminderEnable,
                emailIsSubscribe: data.emailIsSubscribe
            })
        }).catch(error => {
            this.setState({loading:false})
            console.log("Loading Menu Failed", error)
        })
    }
    updateSettings = (type) => {
        this.setState({loading:true})
        get('/updateEmailStatus?email=' + sessionStorage.getItem('loggedInUserInfo') + '&' + type + '=' + this.state[type] + '&access_token='
        ).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({loading:false})

        }).catch(error => {
            this.setState({loading:false})
            console.log("Loading Menu Failed", error)
        })

    }

    constructor() {
        super()
        this.state = {
            lunchReminderEnable: '',
            paymentReminderEnable: '',
            emailIsSubscribe: '',
            loading:false
        }
    }

    render() {
        return (
            <section className="full-width clearfix">
                <div className="container">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '50%'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="sectionTitle">
                        <h2>
                        <span >Set e-mail notification preferences ({' '+ sessionStorage.getItem('loggedInUserInfo')+' ' }) </span>
                            <button className="pull-right btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                this.context.router.history.push('/parent')
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                        </h2>

                    </div>
                    <div className="row">
                        <h5 className="col-lg-4 col-xs-8 col-sm-6 col-md-6">Lunch Order Reminder notifications</h5>
                        <Toggle
                            className="col-lg-4 col-xs-2 col-sm-3 col-md-3"
                            checked={(!this.state.emailIsSubscribe) ? false : this.state.lunchReminderEnable}
                            name='lunchReminderEnable'
                            value='yes'
                            onChange={(e) => this.toggle(e)}
                        />
                    </div>
                    <div className="row">
                        <h5 className="col-lg-4 col-sm-6 col-xs-8 col-md-6">Payment Reminder notifications</h5>
                        <Toggle
                            className="col-lg-4 col-xs-2 col-sm-3 col-md-3"
                            checked={(!this.state.emailIsSubscribe) ? false : this.state.paymentReminderEnable}
                            name='paymentReminderEnable'
                            value='yes'
                            onChange={(e) => this.toggle(e)}
                        />
                    </div>
                    <div className="row">
                        <hr className="col-lg-4 col-sm-6 col-xs-8 col-md-6"></hr>
                    </div>
                    <div className="row">
                        <h5 className="col-lg-4 col-sm-6 col-xs-8 col-md-6">Unsubscribe from all emails</h5>
                        <Toggle
                            className="col-lg-4 col-xs-2 col-sm-3 col-md-3"
                            checked={!this.state.emailIsSubscribe}
                            name='emailIsSubscribe'
                            value='yes'
                            onChange={(e) => this.toggle(e)}
                        />
                    </div>
                </div>
            </section>
        )
    }
}
Notifications.contextTypes = {
    router: PropTypes.object.isRequired
}
export default Notifications


// WEBPACK FOOTER //
// ./src/components/Parent/Home/notifications.js